<mat-tab-group #tabs animationDuration="0ms" tabGroupDrag mat-stretch-tabs="false" mat-align-tabs="start"
               style="overflow: hidden">
    <mat-tab>
        <ng-template mat-tab-label>
            <span class="tab-label-wrap" [matTooltip]="'ai.tabFilesDesc' | transloco" matTooltipPosition="above">
                <mat-icon class="tab-icon">list</mat-icon>
                {{ "general.files" | transloco }}
                <mat-icon class="tab-help-icon">info_outline</mat-icon>
            </span>
        </ng-template>
        <div class="tab-hint">
            <mat-icon>info_outline</mat-icon>
            <span>{{ 'ai.tabFilesDesc' | transloco }}</span>
        </div>
        <mat-drawer-container>
            <mat-drawer-content>
                <div class="list-container main-container">
                    <app-resource-list #appList [setResources]="resources" (toggleMinimize)="sidenav.toggle()"
                                       (fileUpload)="onSwitchFileTab()"></app-resource-list>
                </div>
            </mat-drawer-content>
            <mat-drawer [opened]="sidenavOpened && appList.selection?.selected?.length > 0" [mode]="sidenavMode" position="end" #sidenav
                        [disableClose]="sidenavMode === 'side'">
                <div class="props-container">
                    <app-resource-props [setSelectionModel]="appList.selection"
                                        (updateSelection)="appList.selection = $event"></app-resource-props>
                </div>
            </mat-drawer>
        </mat-drawer-container>
    </mat-tab>
    @if (this.accessConfig?.add !== false) {
        <mat-tab>
            <ng-template mat-tab-label>
                <span class="tab-label-wrap" [matTooltip]="'ai.tabUploadDesc' | transloco" matTooltipPosition="above">
                    <mat-icon class="tab-icon">backup</mat-icon>
                    {{ "general.upload" | transloco }}
                    <mat-icon class="tab-help-icon">info_outline</mat-icon>
                </span>
            </ng-template>
            <div class="tab-hint">
                <mat-icon>info_outline</mat-icon>
                <span>{{ 'ai.tabUploadDesc' | transloco }}</span>
            </div>
            <app-resource-upload [showHelpButton]="true" [category]="appList.categorySelected"></app-resource-upload>
        </mat-tab>
    }

    <mat-tab style="overflow: hidden">
        <ng-template mat-tab-label>
            <span class="tab-label-wrap" [matTooltip]="'ai.tabStockDesc' | transloco" matTooltipPosition="above">
                <mat-icon class="tab-icon">image_search</mat-icon>
                {{ "general.stock" | transloco }}
                <mat-icon class="tab-help-icon">info_outline</mat-icon>
            </span>
        </ng-template>
        <div class="tab-hint">
            <mat-icon>info_outline</mat-icon>
            <span>{{ 'ai.tabStockDesc' | transloco }}</span>
        </div>
        <app-stock-resources></app-stock-resources>
    </mat-tab>
    <!-- The three AI tabs below are gated by the 'SignStudio AI' privilege group.
         Flags default to true so free users and legacy privilege XMLs (no group) always
         see the tabs. Only a reseller explicitly unchecking the toggle hides one.
         See src/app/containers/enterprise/docs/09-adding-privilege-feature-toggles.md -->
    @if (aiMediaProducerEnabled) {
        <mat-tab style="overflow: hidden">
            <ng-template mat-tab-label>
                <span class="tab-label-wrap" [matTooltip]="'ai.tabMediaProducerDesc' | transloco" matTooltipPosition="above">
                    <mat-icon class="tab-icon">auto_awesome</mat-icon>
                    AI media producer
                    <mat-icon class="tab-help-icon">info_outline</mat-icon>
                </span>
            </ng-template>
            <div class="tab-hint">
                <mat-icon>info_outline</mat-icon>
                <span>{{ 'ai.tabMediaProducerDesc' | transloco }}</span>
            </div>
            <app-media-producer-ai></app-media-producer-ai>
        </mat-tab>
    }

    @if (aiAnimatorEnabled) {
        <mat-tab style="overflow: hidden">
            <ng-template mat-tab-label>
                <span class="tab-label-wrap" [matTooltip]="'ai.tabAnimatorDesc' | transloco" matTooltipPosition="above">
                    <mat-icon class="tab-icon">auto_awesome</mat-icon>
                    AI animator
                    <mat-icon class="tab-help-icon">info_outline</mat-icon>
                </span>
            </ng-template>
            <div class="tab-hint">
                <mat-icon>info_outline</mat-icon>
                <span>{{ 'ai.tabAnimatorDesc' | transloco }}</span>
            </div>
            <app-ai-animator></app-ai-animator>
        </mat-tab>
    }

    @if (aiVideoBuilderEnabled) {
        <mat-tab style="overflow: hidden">
            <ng-template mat-tab-label>
                <span class="tab-label-wrap" [matTooltip]="'ai.tabVideoBuilderDesc' | transloco" matTooltipPosition="above">
                    <mat-icon class="tab-icon">auto_awesome</mat-icon>
                    AI video builder
                    <mat-icon class="tab-help-icon">info_outline</mat-icon>
                </span>
            </ng-template>
            <div class="tab-hint">
                <mat-icon>info_outline</mat-icon>
                <span>{{ 'ai.tabVideoBuilderDesc' | transloco }}</span>
            </div>
            <app-ai-video-builder></app-ai-video-builder>
        </mat-tab>
    }

</mat-tab-group>
